import React, { useState ,useEffect} from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner } from "react-bootstrap";
import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import Loader from "./Loader";
import N from '../lib/Network'
import S from '../lib/Security';
var CryptoJS = require("crypto-js");
const ManageTenantAudit = ({ showUserPopupAudit, closeModal }) => {
    const [showLoader, setShowLoader] = useState(false);
    const [data, setData] = useState([]);
    useEffect(() => {
        getKeys();
        fetchdatatableData();
        //initialize datatable viewUser
        setTimeout(function () {
            $('#viewAuditLog').DataTable({
                pagingType: 'full_numbers',
                pageLength: 7,
                dom: 'Bfrtip',
                "order": [[1, "desc"]],
                "columns": [
                    { 'searchable': true },
                    { 'searchable': true },
                    { 'searchable': true },
                    { 'searchable': true },
                    { 'searchable': true },
                    { 'searchable': true },
                ],
                language: { search: "", searchPlaceholder: "Search By ......"},
                buttons: [
                    {
                        text: '<i class="fa fa-print" />',
                        className: 'custom-btn',
                        extend: 'print'
                    },
                    {
                        text: '<i class="fa fa-file-excel-o" />',
                        className: 'custom-btn',
                        extend: 'csv'
                    }
                ],
                bDestroy: true,
                "initComplete": function () {
                    $(this).show();
                }
            });
        }, 500);

    }, []);

    const fetchdatatableData = () => {
        var moduleType = {
            "moduleType":"T"
        }
        N.postApi('getTmsModuleAudit', moduleType)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            console.log("response:"+JSON.stringify(response))
            setData(JSON.parse(response.responseJson))
        })
    }
    function getKeys() {
        if (S.getPrivateKey() == '' && S.getPublicKey() == '') {
            N.getRSAApi('/getRsaKeys')
            .then(res => {
                let resObj = JSON.parse(res.data);
                let resJson = JSON.parse(resObj.responseJson);
                if (resJson.privateKey && resJson.publicKey) {
                    let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                    // Decrypt
                    var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
                    S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);

                    var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
                    S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }
    const closePopup = () => { closeModal() }
    
    
    return (
        <Modal id="" show={showUserPopupAudit} animation={true} size="xl">
            <Modal.Header closeButton onClick={closePopup}>
                <Modal.Title><h5 className="headerTitle">Manage Tenant Audit</h5></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    <Container fluid>
                        <Row className="mb-3">
                            <Col lg='12'>
                            <table id="viewAuditLog" className="display">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Change By</th>
                                                        <th>Primary Value</th>
                                                        <th>Field Name</th>
                                                        <th>Old value</th>
                                                        <th>New value</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {data?.Payload?.ModuleAuditData?.map((result) => {
                                                        return (
                                                            <tr>
                                                                <td>{result.Date}</td>
                                                                <td>{result.changeBy}</td>
                                                                <td>{result.emailId}</td>
                                                                <td>{result.fieldName}</td>
                                                                <td>{result.oldValue}</td>
                                                                <td>{result.newValue}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                            </Col>
                        </Row>
                    </Container>
                    <Loader showLoader={showLoader} />
                </Modal.Body>
            </Modal>
    )
}
export default ManageTenantAudit;